import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function CoinIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M9 11.25c4.142 0 7.5-1.51 7.5-3.375S13.141 4.5 9 4.5 1.5 6.01 1.5 7.875 4.858 11.25 9 11.25Z"
            stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M1.5 7.875v3.75C1.5 13.491 4.856 15 9 15c4.143 0 7.5-1.509 7.5-3.375v-3.75M6 10.97v3.75"
            stroke="currentColor"
            strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M16.5 9.066c3.421.318 6 1.679 6 3.309 0 1.866-3.357 3.375-7.5 3.375-1.838 0-3.525-.3-4.829-.788"
            stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path
        d="M7.5 14.934v1.191c0 1.866 3.355 3.375 7.5 3.375 4.143 0 7.5-1.509 7.5-3.375v-3.75M18 15.47v3.75m-6-8.25v8.25"
        stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </BaseIcon>
  );
}
